module.exports = __webpack_public_path__ + "img/img28.c93e12d4.svg";